import { TaxItemTypeEnum } from './tax-item-type-enum';

export class TaxItem {
  name: string;
  value: number;
  type: TaxItemTypeEnum;
  currency?: string;
  rate?: number;
}
